import App from './App.svelte';

const renderApp = () => {
  const target = document.getElementById('koromap');

  if (!target) {
    return console.log(
      'koro map vis: please add a container with id="koromap" in order to render the app.'
    );
  }

  new App({
    target,
  });
};

renderApp();
